export default [
  {
    country: 'Madagascar🇲🇬',
    wasteReducedInKiloInAWeek : 354,
    // imgSrc: 'https://via.placeholder.com/125x100',
  },
  {
    country: 'Thailand🇹🇭',
    wasteReducedInKiloInAWeek : 184,
    // imgSrc: 'https://via.placeholder.com/125x100',
  },
  {
    country: 'Malaysia 🇲🇾',
    wasteReducedInKiloInAWeek : 39,
    // imgSrc: 'https://via.placeholder.com/125x100',
  },
]
